import { removeWorkDir } from './workDir';
import { Container, Line, ListItem, renderPrompt, Section, UnorderedList } from '~/lib/prompts/prompt-components';
import type { FocusedFiles } from '~/types/chat';

export function getFocusedFiles(focusedFiles?: FocusedFiles): string | undefined {
  if (!focusedFiles) {
    return undefined;
  }

  const files = focusedFiles.targetedFiles.length > 0 ? focusedFiles.targetedFiles : focusedFiles.lockedFiles;

  if (files.length === 0) {
    return undefined;
  }

  return renderPrompt(
    <Section name="focused_files">
      <Container>
        <Line>
          There are some restrictions that apply to this request. If you have to modify files, please make sure to{' '}
          {focusedFiles.targetedFiles.length > 0
            ? 'ONLY make modifications to the following file paths:'
            : 'NOT make ANY modifications to the following file paths:'}
        </Line>

        <UnorderedList indent>
          {files.map((filePath) => (
            <ListItem key={filePath}>{removeWorkDir(filePath)}</ListItem>
          ))}
        </UnorderedList>
      </Container>

      <Line>
        CRITICAL: In the case where you need to modify restricted files, you must ask me to change the restricted files
        configuration first.
      </Line>
    </Section>,
  );
}
